import { ref, nextTick } from 'vue'

// 模块级别的共享状态（单例）
const showRenameDialog = ref(false)
const showDeleteDialog = ref(false)
const newFileName = ref('')
const currentFileName = ref('')
const fileToDelete = ref(null)
const fileToRename = ref(null)

export function useFileDialogs() {
  const openRenameDialog = (file, name, renameInputRef) => {
    currentFileName.value = name
    // 去掉文件扩展名
    const extension = name.lastIndexOf('.')
    newFileName.value = extension > 0 ? name.substring(0, extension) : name
    fileToRename.value = file
    showRenameDialog.value = true
    // 在下一个 tick 聚焦并选中文本
    nextTick(() => {
      if (renameInputRef?.value) {
        renameInputRef.value.focus()
        renameInputRef.value.select()
      }
    })
  }

  const openDeleteDialog = (file, name) => {
    currentFileName.value = name
    fileToDelete.value = file
    showDeleteDialog.value = true
  }

  const closeRenameDialog = () => {
    showRenameDialog.value = false
    fileToRename.value = null
    newFileName.value = ''
    currentFileName.value = ''
  }

  const confirmRename = () => {
    if (newFileName.value && newFileName.value !== currentFileName.value) {
      // 保持原来的扩展名
      const extension = currentFileName.value.lastIndexOf('.')
      const newName = extension > 0
        ? newFileName.value + currentFileName.value.substring(extension)
        : newFileName.value
      fileToRename.value?.emit('renameFile', newName)
    }
    closeRenameDialog()
  }

  const closeDeleteDialog = () => {
    showDeleteDialog.value = false
    fileToDelete.value = null
  }

  const confirmDelete = () => {
    fileToDelete.value?.emit('deleteFile')
    closeDeleteDialog()
  }

  return {
    showRenameDialog,
    showDeleteDialog,
    newFileName,
    currentFileName,
    openRenameDialog,
    openDeleteDialog,
    closeRenameDialog,
    confirmRename,
    closeDeleteDialog,
    confirmDelete
  }
}
